<ng-container *ngIf="isCreateMode() || isUpdateMode()">
  <form (ngSubmit)="save()" [formGroup]="form">
    <base-form-header
      [mode]="mode"
      createLabel="Ajouter un établissement"
      [updateLabel]="form.get('label')?.value"
    ></base-form-header>

    <mat-dialog-content fxLayout="column">
      <mat-stepper #stepper [linear]="true">
        <mat-step [stepControl]="infoStepGroup">
          <ng-template matStepLabel>Informations</ng-template>

          <base-form-input
            [items]="establishmentType"
            label="Type d'établissement"
            type="select"
            controlName="establishmentType"
            [disabled]="isUpdateMode()"
          ></base-form-input>

          <mat-checkbox
            *ngIf="
              form.get('establishmentType')?.value ===
              establishmentTypeFrenchTranslation(establishmentTypeEnum.SUPPORT_FUNCTION)
            "
            formControlName="linkedToMain"
            [disabled]="isUpdateMode()"
          >
            Lier un établissement principal
          </mat-checkbox>

          <base-form-input
            *ngIf="form.get('linkedToMain').value"
            label="Etablissement principal"
            [items$]="establishments$"
            (autocompleteChange)="establishmentAutocompleteChange($event)"
            type="autocomplete"
            controlName="mainEstablishment"
            displayProperty="label"
            [disabled]="isUpdateMode()"
          ></base-form-input>

          <base-form-input label="Libellé" controlName="label"></base-form-input>

          <base-form-input label="Identifiant logiciel comptable" controlName="accountingSoftwareId"></base-form-input>

          <!-- Checkbox type d'entreprise -->
          <div class="mb-4" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="8px">
            <mat-checkbox formControlName="isFrenchCompany" [disabled]="isUpdateMode()">
              Etablissement français
            </mat-checkbox>
            <mat-icon
              matTooltip="Cochez pour un établissement français (SIRET/SIREN) ou décochez pour un établissement étranger (Identifiant entreprise)"
              matTooltipPosition="above"
              class="text-gray-400 cursor-help"
              style="font-size: 18px; height: 18px; width: 18px"
            >
              info_outline
            </mat-icon>
          </div>

          <!-- Ligne 1: Informations fiscales (uniquement pour établissements français) -->
          <div
            *ngIf="form.get('isFrenchCompany')?.value"
            fxLayout="row"
            fxLayoutGap="16px"
            fxLayout.xs="column"
            fxLayoutGap.xs="0px"
          >
            <base-form-input fxFlex="50" label="N° TVA" controlName="tva"></base-form-input>

            <base-form-input fxFlex="50" label="Code APE" controlName="ape"></base-form-input>
          </div>

          <!-- Ligne 2: Numéros d'identification SIRET/SIREN (société française) -->
          <div
            *ngIf="form.get('isFrenchCompany')?.value"
            fxLayout="row"
            fxLayoutGap="16px"
            fxLayout.xs="column"
            fxLayoutGap.xs="0px"
          >
            <div fxFlex="50" class="field-with-top-hint">
              <div class="top-hint mat-hint">&nbsp;</div>
              <base-form-input
                label="N° Siret"
                type="number"
                controlName="siretNumber"
                [minLength]="14"
                [maxLength]="14"
                invalidPatternMessage="Le numéro Siret doit contenir 14 chiffres"
                [disabled]="form.get('linkedToMain')?.value"
              ></base-form-input>
            </div>

            <div fxFlex="50" class="field-with-top-hint">
              <div class="top-hint mat-hint">Auto-complété depuis le Siret</div>
              <base-form-input
                label="N° Siren *"
                type="number"
                controlName="sirenNumber"
                [disabled]="true"
              ></base-form-input>
            </div>
          </div>

          <!-- Ligne 2 bis: Identifiant entreprise (société non française) -->
          <base-form-input
            *ngIf="!form.get('isFrenchCompany')?.value"
            label="Identifiant entreprise"
            controlName="dunsNumber"
          ></base-form-input>

          <!-- Ligne 3: Statut TVA (uniquement pour établissements français) -->
          <base-form-input
            *ngIf="form.get('isFrenchCompany')?.value"
            label="Statut TVA"
            [items]="statusTva"
            type="select"
            controlName="vatStatus"
          ></base-form-input>

          <!-- Ligne 4: Informations comptables -->
          <base-form-input
            label="Comptable de rattachement"
            [items$]="userProfiles$"
            (autocompleteChange)="customerReferentAutocompleteChange($event)"
            type="autocomplete"
            controlName="attachedAccountant"
            displayProperty="fullName"
          ></base-form-input>

          <base-form-input
            label="Plan comptable"
            controlName="accountChart"
            [items$]="accountCharts$"
            (autocompleteChange)="accountChartAutocompleteChange($event)"
            type="autocomplete"
            displayProperty="label"
          ></base-form-input>

          <p class="mb-3">Coordonnées</p>
          <mat-divider class="mb-6"></mat-divider>

          <ng-container [formGroup]="phoneForm">
            <form-phone-input
              [form]="phoneForm"
              [establishmentNumber]="defaults?.phoneNumber"
              [isUpdateMode]="isUpdateMode()"
              [isPhoneNumberRequired]="false"
              [isPreFixRequired]="false"
              [isPhoneTypeRequired]="false"
            ></form-phone-input>
          </ng-container>

          <div class="flex justify-end mt-6">
            <button mat-button (click)="close()">ANNULER</button>
            <button mat-button type="button" color="primary" (click)="goToBillingStep()">SUIVANT</button>
          </div>
        </mat-step>

        <mat-step [stepControl]="billingStepGroup">
          <ng-template matStepLabel>Envoi de facture</ng-template>

          <p class="mb-3 mt-4">Adresse de facturation</p>
          <mat-divider class="mb-4"></mat-divider>

          <mat-radio-group [formControl]="billingModeControl" class="flex flex-row gap-6 mb-4">
            <mat-radio-button value="address">Adresse de bâtiment</mat-radio-button>
            <mat-radio-button value="email">Email de facturation</mat-radio-button>
          </mat-radio-group>

          <ng-container *ngIf="billingModeControl.value === 'address'">
            <base-data-table-header
              label="Adresses"
              [canCreate]="false"
              (onSearchChange)="onAddressSearch($event)"
              (onClearTextFilter)="onAddressSearch('')"
            ></base-data-table-header>

            <div class="address-table-container">
              <base-data-table
                [dataSource]="addressesDataSource"
                [count]="addressCount"
                [pageSize]="addressPageSize"
                [sortField]="addressSortField"
                [sortOrder]="addressSortOrder"
                [feisColumns]="addressColumns"
                [displayedColumns]="addressDisplayedColumns"
                [customColumnTemplate]="addressCustomColumn"
                (onPageEvent)="onAddressPage($event)"
                (onSortEvent)="onAddressSort($event)"
                (onRowClick)="selectBillingAddress($event)"
              ></base-data-table>
            </div>

            <ng-template #addressCustomColumn let-column let-row="element">
              <ng-container *ngIf="column === 'buildingsInfo'; else defaultTpl">
                <span *ngIf="row?.buildingsInfo?.length; else noBuilding">
                  <ng-container *ngFor="let b of row.buildingsInfo; let last = last">
                    {{ b?.label }}
                    <span *ngIf="!last">,</span>
                  </ng-container>
                </span>
                <ng-template #noBuilding>-</ng-template>
              </ng-container>
              <ng-template #defaultTpl></ng-template>
            </ng-template>

            <p *ngIf="form.get('billingAddress').value" class="mt-4">
              Adresse sélectionnée : {{ form.get('billingAddress').value | formatAddress }}
            </p>
          </ng-container>

          <ng-container *ngIf="billingModeControl.value === 'email'">
            <base-form-input
              label="Email de facturation"
              type="text"
              controlName="billingEmail"
              placeholder="email@exemple.com"
            ></base-form-input>
          </ng-container>

          <div class="flex justify-end mt-6">
            <button mat-button type="button" (click)="goToInfoStep()">PRECEDENT</button>
            <button mat-button type="button" color="primary" (click)="goToPaymentStep()">SUIVANT</button>
          </div>
        </mat-step>

        <mat-step [stepControl]="paymentStepGroup">
          <ng-template matStepLabel>Règlement</ng-template>

          <p class="mb-3 mt-4">Mode de règlement</p>
          <mat-divider class="mb-4"></mat-divider>

          <payment-method-selector
            [formGroup]="form"
            paymentMethodControlName="paymentMethod"
            ibanControlName="paymentMethodIban"
            bicControlName="paymentMethodBic"
          ></payment-method-selector>

          <div class="flex justify-end mt-6">
            <button mat-button type="button" (click)="goBackFromPaymentStep()">PRECEDENT</button>
            <base-form-input
              type="submit"
              [mode]="mode"
              [loading]="loading"
              entityLabel="ESTABLISHMENT"
              (onCreate)="createItem()"
              (onUpdate)="updateItem()"
            ></base-form-input>
          </div>
        </mat-step>
      </mat-stepper>
    </mat-dialog-content>
  </form>
</ng-container>

<ng-container *ngIf="isDeleteMode()">
  <form-modal-delete-base
    [label]="data.name"
    (onClose)="close()"
    [loading]="loading"
    (onDelete)="deleteItem()"
  ></form-modal-delete-base>
</ng-container>

<ng-container *ngIf="isImportMode()">
  <vex-form-import-base
    [modalTitle]="'Importer des établissements'"
    [entityLabel]="'ESTABLISHMENT'"
    [form]="importForm"
    [service]="service"
    [mode]="mode"
    [loading]="loading"
    (saveForm)="save()"
    (importItems)="importItemsCombined()"
    [downloadModel]="canDownloadModelPermissions"
    [customExport]="true"
    (fileSelected)="fileSelected($event)"
    (customExportItems)="downloadEstablishmentsTemplateCombined()"
    [canDownloadTemplateModel]="true"
    [collectionName]="'establishments'"
  ></vex-form-import-base>
</ng-container>

<ng-container *ngIf="isArchiveMode()">
  <form-modal-delete-base
    (onClose)="close()"
    (onDelete)="archiveItem()"
    title="Archiver l'établissement"
    defaultMessage="Êtes-vous sûr de vouloir archiver cet établissement ?"
  ></form-modal-delete-base>
</ng-container>
